import * as yup from 'yup';
import { PUPPY_TYPE_NAME, STUD_TYPE_NAME } from '../../../utils/constants';

const SellerContactValidation = yup.object()
  .shape({
    name: yup
      .string()
      .required('Name is required')
      .max(80, 'Name must be a maximum of 80 characters'),
    email: yup
      .string()
      .email('Invalid email format')
      .required('Email is required')
      .max(255, 'Email must be a maximum of 255 characters'),
    phone: yup
      .string()
      .nullable()
      .test('valid-phone', 'Please enter a valid phone number.', (value) => {
        if (value && value.length === 10) {
          return yup.string()
            .isValidSync(value);
        }
        return true; // No error if length is not 10
      })
      .test('phone-length', 'Phone number must be 10 digits', (value) => {
        if (value) {
          return value.length === 10;
        }
        return true; // No error if value is empty
      }),
    message: yup
      .string()
      .required('You must type a message')
      .max(1000, 'Message must be a maximum of 1000 characters'),
    seller_id: yup
      .string()
      .required('Seller ID is required'),
    listing_id: yup.string()
      .nullable(),
    listing_type: yup
      .string()
      .nullable()
      .oneOf(
        [PUPPY_TYPE_NAME, STUD_TYPE_NAME],
        'Invalid listing type',
      ),
    listing_name: yup
      .string()
      .required('Listing name is required')
      .max(100, 'Listing name must be a maximum of 100 characters'),
  });

export default SellerContactValidation;
